import { useContext, useEffect, useState } from 'react';
import { BiEdit } from 'react-icons/bi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { showErrorToast } from "../../../../Toster";
import AlertContext from "../../../../context/Alert/AlertContext";
import DataTable2 from '../../../DataTable2';
import axiosPrivate from '../../../../hooks/axiosPrivate';
import TopNavBar from '../../layouts/TopNavBar';
import AuthContext from '../../../../context/Auth/AuthContext';
import LoaderContext from '../../../../context/Loader/LoaderContext';

const Blog = () => {
	const { alertMessage, setAlertMessage } = useContext(AlertContext);
	const { authPermissions } = useContext(AuthContext);
	const [blogState, setBlogState] = useState([]);
	const { setLoaderCheck } = useContext(LoaderContext);


	function formatDate(inputDate) {
		// Create a Date object from the input string
		const date = new Date(inputDate);
	  
		// Define options for formatting the date
		const options = {
		  year: 'numeric',
		  month: 'short',
		  day: 'numeric',
		};
	  
		// Use the toLocaleDateString method to format the date
		const formattedDate = date.toLocaleDateString('en-US', options);
	  
		return formattedDate.toUpperCase();
	  }
	// header
	const headers = [
		// { name: 'S No', field: 'sr-no', sortable: true, classKey: '' },
		{
			name: 'BLOG TITLE',
			field: 'title',
			sortable: true,
			classKey: '',
		},
		{ name: 'SLUG', field: 'slug', sortable: true, classKey: '' },

		{ name: 'STATUS', field: 'status', sortable: true, classKey: '' },
		{
			name: 'PUBLISH DATE',
			field: 'publish_date',
			sortable: true,
			classKey: '',
		},

		{ name: 'ACTION', field: 'action', classKey: '' },
	];
	// search item
	const searchItems = ['title'];
	//  blogs data list
	useEffect(() => {
		const options = {
			headers: { 'content-type': 'application/json' },
		};
		setLoaderCheck(true);
		axiosPrivate.get('blogs', options)
			.then((blogs) => {
				setLoaderCheck(false);
				const blogData = blogs?.data?.data?.map((value, index) => {
					let buttons = [];
					if (authPermissions.includes('Blog-update'))
						buttons.push(
							<Link
								key="editButton##1"
								type="button"
								to={`/admin/blog/edit/${value.id}`}
								className="btn btn-icon"
								title="Edit"
							>
								<BiEdit style={{ color: 'green' }} size={18} />
							</Link>
						);
					if (authPermissions.includes('Blog-delete'))
						buttons.push(
							<button
								key="deleteButton##1"
								type="button"
								data-id={value.id}
								onClick={() => blogDeleteHandler(value.id)}
								className="btn btn-icon js-sweetalert"
								title="Delete"
							>
								<RiDeleteBinLine style={{ color: 'red' }} size={17} />
							</button>
						);
						value["sr-no"]=index+1
						value["publish_date"]=formatDate(value?.publish_date)
					value['action'] = buttons.length > 0 ? buttons : '-';

					return value; 
				});

				if (authPermissions.includes('Blog-read')) {
					setBlogState(blogData);
				} else {
					setBlogState([]);
				}
			})
			.catch((error) => {
				setLoaderCheck(false);
				showErrorToast(error.message);
			})
	}, []);

	// alert
	useEffect(() => {
		if (alertMessage != null) {
			toast(alertMessage.message, {
				position: 'top-right',
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
			setAlertMessage(null);
		}
	}, [alertMessage]);

	// delete function

	const blogDeleteHandler = async (id) => {
		setLoaderCheck(true);
		axiosPrivate
			.delete(`blogs/${id}`)
			.then(async (response) => {
				setLoaderCheck(false);
				if (response.data.code == 200) {
					setBlogState([]);
					setAlertMessage({ message: 'Blog  Deleted Successfully!' });
					await refreshTable();
				}
			})
			.catch((error) => {
				setLoaderCheck(false);
				if (typeof error.response.data.errors === 'array') {
					showErrorToast(error.response.data.errors[0].msg);
				} else {
					showErrorToast(error.response.data.errors.msg);
				}
			});
	};
	// refreshTable (delete data after get list)
	const refreshTable = () => {
		return new Promise((resolve, reject) => {
			const options = {
				headers: { 'content-type': 'application/json' },
			};
			setLoaderCheck(true);
			axiosPrivate.get('blogs', options)
				.then((blogs) => {
					setLoaderCheck(false);
					const blogData = blogs.data.data.map((value, key) => {
						let buttons = [];
						if (authPermissions.includes('Blog-update'))
							buttons.push(
								<button
									key="editButton##1"
									type="button"
									className="btn btn-icon"
									title="Edit"
								>
									<BiEdit style={{ color: 'green' }} size={18} />
								</button>
							);
						if (authPermissions.includes('Blog-delete'))
							buttons.push(
								<button
									key="deleteButton##1"
									type="button"
									data-id={value.id}
									onClick={() => blogDeleteHandler(value.id)}
									className="btn btn-icon js-sweetalert"
									title="Delete"
								>
									<RiDeleteBinLine style={{ color: 'red' }} size={17} />
								</button>
							);
						value['action'] = buttons.length > 0 ? buttons : '-';
						return value;
					});

					if (authPermissions.includes('Blog-read')) {
						setBlogState(blogData);
					} else {
						setBlogState([]);
					}

					resolve(true);
				})
				.catch((error) => {
					setLoaderCheck(false);
				  showErrorToast("Internal Server Error")
				})
		});
	};

	const addLink = authPermissions.includes('Blog-create') === true ? '/admin/blog/add' : '';

	return (
		<>
			<TopNavBar links={{ list: '/admin/blog', add: addLink }} />
			<div className="section-body">
				<div className="container-fluid">
					<div className="tab-content">
						<div
							className="tab-pane fade show active"
							id="user-list"
							role="tabpanel"
						>
							<div className="card">
								<div className="card-body">
									<div className="table-responsive">
										{
											<DataTable2
												lists={blogState}
												headers={headers}
												searchItems={searchItems}
											/>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Blog;
